/* pinterest module */

import uiRouter from '@uirouter/angularjs';

import { AppShellModule } from 'components/appShell/appShell.module';

import './pinterest.scss';

export const PinterestModule = angular
    .module('app.pages.pinterest', [
        uiRouter,
        AppShellModule
    ]).config(($stateProvider) => {
        'ngInject';

        $stateProvider.state({
            parent: 'apps',
            name: 'pinterest',
            url: '/pinterest',
            component: 'appShell',
            resolve: {
                title: () => { return 'Pinterest'; },
                trackingId: () => { return 'pinterest'; },
                src: () => 'https://volusion-pinterest-app-168120.appspot.com'
            },
            data: {
                page: 'pinterest'
            }
        });
    }).name;



// WEBPACK FOOTER //
// ./src/app/pages/pinterest/pinterest.module.js